(() => {
  const revealConvertedPrices = (container) => {
    const prices = [...container.querySelectorAll('.new-price, .old-price')];

    if (!prices.length || prices.every((price) => price.classList.contains('buckscc-converted'))) {
      container.removeAttribute('data-currency-pending');
    }
  };

  const scan = (root = document) => {
    if (root.matches?.('[data-currency-pending]')) revealConvertedPrices(root);
    root.querySelectorAll?.('[data-currency-pending]').forEach(revealConvertedPrices);
  };

  scan();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const container = mutation.target.closest?.('[data-currency-pending]');
      if (container) revealConvertedPrices(container);

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) scan(node);
      });
    });
  });

  observer.observe(document.body, {attributes: true, childList: true, subtree: true});
})();
